import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RefreshIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <Path
      stroke="#3379BD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.334 8.5c0-1.24.41-2.446 1.17-3.43a5.669 5.669 0 0 1 3.03-2.01 5.702 5.702 0 0 1 3.637.237 5.655 5.655 0 0 1 2.738 2.388m-3.492 0h3.542V2.166m.708 6.333c0 1.24-.41 2.445-1.17 3.429a5.668 5.668 0 0 1-3.03 2.011 5.702 5.702 0 0 1-3.636-.237 5.656 5.656 0 0 1-2.74-2.388m3.493 0H3.042v3.519"
    />
  </Svg>
);
export default RefreshIcon;
